/**
 * NOS-110: Default page seeding for new orgs.
 * NOS-157: now a thin wrapper — the default site is expressed as a theme
 * package (src/themes/default.json) and seeded through applyThemeAtSignup,
 * the same path the theme gallery uses. Output is identical to the old
 * hardcoded DEFAULT_PAGES skeleton (guarded by themePackages tests).
 */

import { applyThemeAtSignup, validateThemePackage } from "@/lib/themePackages"
import defaultThemeJson from "@/themes/default.json"

/** The built-in default theme package, validated once at module load. */
export function getDefaultThemePackage() {
  const result = validateThemePackage(defaultThemeJson)
  if (!result.ok) {
    throw new Error(`Built-in default theme package is invalid: ${result.errors.join("; ")}`)
  }
  return result.pkg
}

/** Idempotent: seeds default pages for org if none exist. Returns error or null. */
export async function seedPagesForOrg(orgId: string): Promise<Error | null> {
  return applyThemeAtSignup(orgId, getDefaultThemePackage())
}
